import { all } from 'redux-saga/effects';
import authSaga from './auth/sagas';
import reportsSaga from './reports/sagas';
import settingSaga from './setting/sagas';
import offlineStackSaga from './offlineStack/sagas';

export default function* root() {
  yield all([...offlineStackSaga, ...authSaga, ...reportsSaga, ...settingSaga]);
}
